import { BUSINESS_ONBOARDING_STEP, BUSINESS_ONBOARDING_STEPS_MAP } from '../BusinessOnboarding';

export type AppState = {
  user: User;
  sourceEntity: EntityFields;
  leftMenuVisibility?: boolean;
  businessOnboardingDetails: BusinessOnboardingDetails;
};

export const initialState: AppState = {
  user: null,
  sourceEntity: null,
  leftMenuVisibility: false,
  businessOnboardingDetails: { step: null, state: null },
};

export enum ActionTypes {
  SET_USER = 'appActionTypes/SET_USER',
  SET_SOURCE_ENTITY = 'appActionTypes/SET_SOURCE_ENTITY',
  SET_LEFT_MENU_VISIBILITY = 'appActionTypes/SET_LEFT_MENU_VISIBILITY',
  SET_BUSINESS_ONBOARDING_DETAILS = 'appActionTypes/SET_BUSINESS_ONBOARDING_DETAILS',
}

export const reducer = (state: AppState = initialState, action: StoreAction): AppState => {
  switch (action.type) {
    case ActionTypes.SET_USER:
      return { ...state, user: action.payload };
    case ActionTypes.SET_SOURCE_ENTITY:
      return { ...state, sourceEntity: action.payload };
    case ActionTypes.SET_LEFT_MENU_VISIBILITY:
      return { ...state, leftMenuVisibility: action.payload };
    case ActionTypes.SET_BUSINESS_ONBOARDING_DETAILS:
      const businessOnboardingDetails = action.payload;
      if (businessOnboardingDetails && businessOnboardingDetails.step) {
        const onbordingStep = Object.keys(BUSINESS_ONBOARDING_STEPS_MAP).find(
          // @ts-ignore
          (key: BUSINESS_ONBOARDING_STEP) => BUSINESS_ONBOARDING_STEPS_MAP[key] === businessOnboardingDetails.step
        );
        if (onbordingStep !== undefined) {
          return { ...state, businessOnboardingDetails: { ...businessOnboardingDetails, step: onbordingStep } };
        }
      }

      return { ...state, businessOnboardingDetails };

    default:
      return state;
  }
};

export const setUser = (value: User) => ({
  type: ActionTypes.SET_USER,
  payload: value,
});

export const setSourceEntity = (value: EntityFields) => ({
  type: ActionTypes.SET_SOURCE_ENTITY,
  payload: value,
});

export const setLeftMenuVisibility = (value: boolean) => ({
  type: ActionTypes.SET_LEFT_MENU_VISIBILITY,
  payload: value,
});

export const setBusinessOnboardingDetails = (data: BusinessOnboardingDetails) => ({
  type: ActionTypes.SET_BUSINESS_ONBOARDING_DETAILS,
  payload: data,
});
